module.exports = __webpack_public_path__ + "media/images/RightFaq-d1b22c12f043a6270f76cc84a1ca17b1.png";